import {Http, http} from "./http";
import { Company } from "./company";
import moment from 'moment'
import { deleteTrannsferByRefNo } from "./Transfers/transfers";
import { TransfersActionTypes } from "store/types/transfers";
import { API_URL } from "./config";

export interface Account {
    ACCOUNT_NO: string;
    ACCOUNT_TYPE: string;
    BALANCE: string;
    BALANCE_LC: string;
    BLOCKSAMOUNT: string;
    BLOCKSTATUS: string;
    BRANCH_NAME: string;
    BRANCH_NO: string;
    CCY_NAME: string;
    COMPASSACCOUNT: string;
    CREDIT_BALANCE: string;
    CUSTOMER_NO: number;
    DEBIT_BALANCE: string;
    IBAN: string;
    INTEREST_ACC: string;
    LAST_BALANCE: string;
    LAST_DAY_BALANCE: string;
    NICKNAME: string;
    OPENDATE: string;
    ORJ_IBAN: string;
    PRODUCT_CODE: string;
    PRODUCT_NAME: string;
    REAL_BALANCE: number;
    STATUS: string;
    WFA_AMOUNT: string;
    WFA_DEBIT: string;
    WFA_CREDIT: string;
    WFA_COMMISSION: string;
};

export interface AccountOperations {
    trn_date: string;
    trn_time: string;
    trn_name: string;
    amount: string;
    currency_name: string;
    status: string;
    descrption: string;
    tx_fid: string;
    TYPE: string;
    account_no: string;
    account_iban: string;
    account_nickname: string;
    debit_credit_flag: string;
    channel: string;
    account_product: string;
    receiver_iban: string;
    receiver_name: string;
    trnCaller: string;
};

export interface AccountOperationFilters {
    page: number,
    activeKey: string
}

export interface Balance {
    AFTERAPPROVE_BALANCE: number;
    AFTERAPPROVE_BALANCE_LC: number;
    AVAIL_BALANCE: number;
    AVAIL_BALANCE_LC: number;
    BALANCE: number;
    BALANCE_LC: number;
    BLOCK_BALANCE: number;
    BLOCK_BALANCE_LC: number;
    CCY_ID: number;
    CCY_NAME: string;
    WAITING_BALANCE: number;
    WAITING_BALANCE_LC: number;
}

export interface AccountsStatement {
    startDate: string,
    endDate: string,
    systemDate: string,
    customerName: string,
    taxNo: string,
    iban: string,
    ccyType: string,
    startBalance: number,
    crBalance: number,
    drBalance: number,
    endBalance: number,
    startBalanceLC: number,
    crBalanceLC: number,
    drBalanceLC: number,
    endBalanceLC: number,
    textCondition: string,
    pageCount: number,
    statementRows: [
        {
            seqNum: number,
            transactionDate: string,
            transactionTime: string,
            transactionRef: string,
            counterCustomerName: string,
            description: string,
            amountCr: number,
            amountDr: number,
            amountCrLC: number,
            amountDrLC: number,
            balanceAmount: number,
            balanceAmountLC: number,
            rate: number
        }
    ]
}



export interface AccountStatementInputDetail {
    startDate: Date;
    endDate: Date;
    ibanRef: any;
    iban?:any
    otp?: string
}
export interface CardsStatement {
    StartDate: string,
    EndDate: string,
    systemDate: string,
    customerName: string,
    taxNo: string,
    Iban: string,
    ccyType: string,
    startBalance: number,
    crBalance: number,
    drBalance: number,
    endBalance: number,
    startBalanceLC: number,
    crBalanceLC: number,
    drBalanceLC: number,
    endBalanceLC: number,
    textCondition: string,
    pageCount: number,
    statementRows: [
        {
            seqNum: number,
            transactionDate: string,
            transactionTime: string,
            transactionRef: string,
            counterCustomerName: string,
            description: string,
            amountCr: number,
            amountDr: number,
            amountCrLC: number,
            amountDrLC: number,
            balanceAmount: number,
            balanceAmountLC: number,
            rate: number
        }
    ]
}
export interface CardStatementInputDetail {
    StartDate: Date;
    EndDate: Date;
    ibanRef: any;
    pan:string
    type: any
    otp?: string
}

export interface CardType{
    type:string;
}
export interface PaginationDatas {
    pageSize: number;
    current: number;
}

export interface AccountsStatementBlockedIban {
    branchNo: number,
    customerNo: number,
    iban: string,
    blockAmount: number,
    blockId: number,
    blockDate: string,
    descriptio: string,
    branchName: string
}

export interface BlockedIbanDetailInput {
    ibanRef: number;
};

export interface IbanRef {
    ibanRef: number;
};

export interface AccountStatementFile {
    status: any,
    data: {
        fileDetailsList: [
            {
                fileBase64: any;
                pmtid: any;
                fileName: any;
                mimeType: any;
            }
        ];
    }

};

export interface IbanRef {
    ibanRef: number;
};

export interface Requisite {
    customerName: string,
    customerAddress: string,
    bankName: string,
    bankVoen: string,
    bankAddress: string,
    bankPhone: string,
    bankEmail: string,
    accountCcyId: number,
    rekvizitAzn: [
        {
            ccyType: string,
            customerName: string,
            customerVoen: string,
            iban: string,
            bankName: string,
            bankCode: number,
            bankAddress: string,
            bankAccount: number,
            bankVoen: number,
            bankSwift: number,
            muhbirAccount: number,
            muhbirName: number,
            muhbirAddress: number,
            muhbirVoen: number,
            muhbirSwift: number,
            muhbirKpp: number,
            muhbirBik: number,
            muhbirMH: number
        }
    ]
}


export const getAccounts = async (company: Company): Promise<Account[]> => {
    const { data } = await http.get<Account[]>(`customers/${company.customerNo}/accounts`);
    return data;
};

export const deleteTransferNew = async (deleteRef: Array<any>, description: string): Promise<any> => {
    const req = {
        "trnRequestType": "DELETE",
        "description": description,
        "fileDescriptors": deleteRef
    }
    const { data } = await http.post<any>(`${API_URL}transaction/delete`, req);
    return data;
};

export const getOldAccounts = async (company: Company): Promise<Account[]> => { //1001301
    const { data } = await http.get<Account[]>(`brcards/get-old-business-cards-by-cif/${company.customerNo}`);
    return data;
};

export const getSavedDocuments = async (ibankref :any): Promise<Account[]> => {
    const { data } = await http.get<Account[]>(`file/getsaveddocuments?ibankref=${ibankref}`);
    return data;
}
export const getAccountOperations = async (company: Company, page: AccountOperationFilters,open:any): Promise<AccountOperations[]> => {
    // const { data } = await http.get<AccountOperations[]>(`customers/${company.customerNo}/activities?period=${period.period}`);
   if(open[0].toString() !== '0') {
        if (page.activeKey === "DR" || page.activeKey === "CR") {
            const {data} = await http.get<AccountOperations[]>(`customers/${company.customerNo}/activities-byfilter?page=${page.page}&limit=20&debit_credit_flag=${page.activeKey}`);
            return data;
        } else {
            const {data} = await http.get<AccountOperations[]>(`customers/${company.customerNo}/activities-byfilter?page=${page.page}&limit=20`);
            return data;
        }
    }


};

export const getBalance = async (company: Company): Promise<Balance[]> => {
    const { data } = await http.get<Balance[]>(`customers/${company.customerNo}/balance`);
    return data;
};

// export const getAccountStatement = async (company: Company, formData: AccountStatementInputDetail, PaginationDatas: PaginationDatas): Promise<AccountsStatement[]> => {

//     let startDate = moment(formData.startDate).format("DD.MM.YYYY");
//     let endDate = moment(formData.endDate).format("DD.MM.YYYY");

//     const { data } = await http.get<AccountsStatement[]>(`customers/${company.customerNo}/accounts/extre/${formData.ibanRef}/${startDate}/${endDate}?page=${PaginationDatas.current}&limit=${PaginationDatas.pageSize}`);
//     return data;
// };

export const getAccountStatement = async (company: Company, formData: AccountStatementInputDetail, PaginationDatas: PaginationDatas , otp?: string): Promise<AccountsStatement[]> => {

    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");

    const { data } = await http.post<any>(`customers/${company.customerNo}/accounts/extre`, { iban: formData.ibanRef, startDate, endDate, ...(formData.otp ? { otp: formData.otp } : {}) });
    return data;
};

export const getCardStatement = async (company: Company, formData: CardStatementInputDetail): Promise<CardsStatement[]> => {
    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");
    const { data } = await http.post<any>(`/brcards/get-card-statement-by-iban/${company.customerNo}`, { cardtype: formData.type, iban: formData.ibanRef, startDate, endDate, ...(formData.otp ? { otp: formData.otp } : {}) });
    return data;
};
export const getCardStatementByPan = async (company: Company, formData: CardStatementInputDetail, otp?: string): Promise<CardsStatement[]> => {
    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");
 const otpValue = otp || formData.otp;
 const { data } = await http.post<any>(`/brcards/get-card-statement-by-pan/${company.customerNo}`, { cardtype: formData.type, pan: formData.pan, startDate, endDate, ...(otpValue ? { otp: otpValue } : {}) });
 return data;
};
export const getBlockedIbanService = async (company: Company, ibanRef: BlockedIbanDetailInput): Promise<AccountsStatementBlockedIban[]> => {
    const { data } = await http.post<any>(`customers/${company.customerNo}/accounts/blocksbyiban`, { iban: ibanRef });
    return data;
}

export const getAccountStatementPdfByIbanRef = async (formData: AccountStatementInputDetail, lang: any, otp?: string): Promise<AccountStatementFile> => {

    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");
    const httpNew = new Http(lang)
    const otpValue = otp || formData.otp;
    const { data } = await httpNew.post<any>(`file/get-extre-pdf-byiban`, { iban: formData.ibanRef, startDate, endDate, ...(otpValue ? { otp: otpValue } : {}), reportType: 'STD' });
    return data;
};


export const getAccountStatementPdfLCByIbanRef = async (formData: AccountStatementInputDetail, lang: any, otp?: string): Promise<AccountStatementFile> => {
    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");
    const httpNew = new Http(lang)
    const iban = formData.ibanRef || formData.iban
    const otpValue = otp || formData.otp;
    const { data } = await httpNew.post<any>(`file/get-extre-pdf-byiban`, { iban, startDate, endDate, ...(otpValue ? { otp: otpValue } : {}), reportType: 'LC' });
    return data;
};


export const getAccountStatementExcelByIbanRef = async (formData: AccountStatementInputDetail, lang: any, otp?: string): Promise<AccountStatementFile> => {
    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");
    const httpNew = new Http(lang)
    const otpValue = otp || formData.otp;
    const { data } = await httpNew.post<any>(`file/get-extre-excel-byiban`, { iban: formData.ibanRef, startDate, endDate, ...(otpValue ? { otp: otpValue } : {}), reportType: 'STD' });
    return data;
};

export const getAccountStatementExcelLCByIbanRef = async (formData: AccountStatementInputDetail, lang: any, otp?: string): Promise<AccountStatementFile> => {
    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");
    const httpNew = new Http(lang)
    const iban = formData.ibanRef || formData.iban
    const otpValue = otp || formData.otp;
    const { data } = await httpNew.post<any>(`file/get-extre-excel-byiban`, { iban, startDate, endDate, ...(otpValue ? { otp: otpValue } : {}), reportType: 'LC' });
    return data;
};
// export const getAccountStatementPdfByIbanRef = async (formData: AccountStatementInputDetail, lang: any, otp?: string): Promise<AccountStatementFile> => {

//     let startDate = moment(formData.startDate).format("DD.MM.YYYY");
//     let endDate = moment(formData.endDate).format("DD.MM.YYYY");
//     const httpNew = new Http(lang)
//     const otpValue = otp || formData.otp;
//     const { data } = await httpNew.post<any>(`file/get-extre-pdf-byiban`, { iban: formData.ibanRef, startDate, endDate, ...(otpValue ? { otp: otpValue } : {}), reportType: 'STD', page: 1, limit: 50 });
//     return data;
// };


// export const getAccountStatementPdfLCByIbanRef = async (formData: AccountStatementInputDetail, lang: any, otp?: string): Promise<AccountStatementFile> => {
//     let startDate = moment(formData.startDate).format("DD.MM.YYYY");
//     let endDate = moment(formData.endDate).format("DD.MM.YYYY");
//     const httpNew = new Http(lang)
//     const iban = formData.ibanRef || formData.iban
//     const otpValue = otp || formData.otp;
//     const { data } = await httpNew.post<any>(`file/get-extre-pdf-byiban`, { iban, startDate, endDate, ...(otpValue ? { otp: otpValue } : {}), reportType: 'LC', page: 1, limit: 50 });
//     return data;
// };


// export const getAccountStatementExcelByIbanRef = async (formData: AccountStatementInputDetail, lang: any, otp?: string): Promise<AccountStatementFile> => {
//     let startDate = moment(formData.startDate).format("DD.MM.YYYY");
//     let endDate = moment(formData.endDate).format("DD.MM.YYYY");
//     const httpNew = new Http(lang)
//     const otpValue = otp || formData.otp;
//     const { data } = await httpNew.post<any>(`file/get-extre-excel-byiban`, { iban: formData.ibanRef, startDate, endDate, ...(otpValue ? { otp: otpValue } : {}), reportType: 'STD', page: 1, limit: 50 });
//     return data;
// };

// export const getAccountStatementExcelLCByIbanRef = async (formData: AccountStatementInputDetail, lang: any, otp?: string): Promise<AccountStatementFile> => {
//     let startDate = moment(formData.startDate).format("DD.MM.YYYY");
//     let endDate = moment(formData.endDate).format("DD.MM.YYYY");
//     const httpNew = new Http(lang)
//     const iban = formData.ibanRef || formData.iban
//     const otpValue = otp || formData.otp;
//     const { data } = await httpNew.post<any>(`file/get-extre-excel-byiban`, { iban, startDate, endDate, ...(otpValue ? { otp: otpValue } : {}), reportType: 'LC', page: 1, limit: 50 });
//     return data;
// };
export const getRequisite = async (company: Company, ibanRef: IbanRef): Promise<Requisite[]> => {
    const { data } = await http.post<any>(`customers/${company.customerNo}/accounts/rekvizit`, { iban: ibanRef });
    return data;
};


export const getRequisitePDFfile = async (formData: IbanRef,lang:any): Promise<AccountStatementFile> => {
    const httpNew = new Http(lang)
    const { data } = await httpNew.post<any>(`file/get-rekvizit-pdf`, { iban: formData.ibanRef });
    return data;
};


// export const getRequisite = async (company: Company, ibanRef: IbanRef): Promise<Requisite[]> => {
//     const { data } = await http.post<any>(`customers/${company.customerNo}/accounts/rekvizit`, { iban: ibanRef });
//     return data;
// };


// export const getRequisitePDFfile = async (formData: IbanRef,lang:any): Promise<AccountStatementFile> => {
//     const httpNew = new Http(lang)
//     const { data } = await httpNew.post<any>(`file/get-rekvizit-pdf`, { iban: formData.ibanRef });
//     return data;
// };

/*export const createAccount = async (user: Account): Promise<Account> => {
    const { data } = await http.post<Account>("/users", user);
    return data;
};

export const updateAccount = async (user: Account): Promise<Account> => {
    const { data } = await http.put<Account>(`/users/${user.id}`, user);
    return data;
};

export const deleteAccount = async (user: Account): Promise<Account> => {
    const { data } = await http.delete<Account>(`/users/${user.id}`);
    return data;
};*/
